import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import { canvasToolbarShellVariants } from "./canvasToolbarStyles";

export type CanvasToolbarRegister = "contextual" | "primary";
export type CanvasToolbarOrientation = "horizontal" | "vertical";

interface CanvasToolbarShellProps extends ComponentPropsWithoutRef<"div"> {
  register?: CanvasToolbarRegister;
  orientation?: CanvasToolbarOrientation;
}

export function CanvasToolbarShell({
  register = "contextual",
  orientation = "horizontal",
  className,
  children,
  ...rest
}: CanvasToolbarShellProps) {
  return (
    <div
      role="toolbar"
      aria-orientation={orientation}
      className={cn(
        canvasToolbarShellVariants({ register, orientation }),
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
